module.exports = __webpack_public_path__ + "static/media/product-pdf-yellow.1e7cb29a.svg";